import { render, staticRenderFns } from "./contato.vue?vue&type=template&id=4e5241cc&scoped=true&"
import script from "./contato.vue?vue&type=script&lang=js&"
export * from "./contato.vue?vue&type=script&lang=js&"
import style0 from "./contato.vue?vue&type=style&index=0&id=4e5241cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5241cc",
  null
  
)

export default component.exports